'use client'

import Image from 'next/image'

const RightContent: React.FC = () => {
  return (
    <section className="min-h-screen w-full bg-green-thin pb-[50px] pe-[84px] pt-[52px]">
      <div className="mb-6 h-[579px] w-[626px]">
        <Image
          src="/images/revpay-auth-img.png"
          height={579}
          width={626}
          alt="Auth pages pics"
          className="object-cover"
        />
      </div>
      <div className="ms-9">
        <h2 className="mb-6 text-5xl font-extrabold leading-[72px] text-primary-green-main">
          RevvaPay: Business Beyond
          {' '}
          <span className="font-medium italic text-primary-yellow-main">
            Borders
          </span>
        </h2>
        <p className="text-lg font-medium leading-[34px] text-primary-green-dark">
          We serve as your Merchant of Record (MoR) giving small
          <br />
          thriving businesses access to a global marketplace swiftly
        </p>
      </div>
    </section>
  )
}

export default RightContent
